export const curriculum: Record<string, Record<string, string[]>> = {
  "수학 I": {
    "지수함수와 로그함수": ["지수와 로그", "지수함수와 로그함수"],
    "삼각함수": ["삼각함수의 뜻과 그래프", "사인법칙과 코사인법칙"],
    "수열": ["등차수열과 등비수열", "수열의 합과 수학적 귀납법"],
  },
  "수학 II": {
    "함수의 극한과 연속": ["함수의 극한", "함수의 연속"],
    "미분": ["미분계수와 도함수", "도함수의 활용"],
    "적분": ["부정적분과 정적분", "정적분의 활용"],
  },
  "확률과 통계": {
    "경우의 수": ["순열과 조합", "이항정리"],
    "확률": ["확률의 뜻과 활용", "조건부확률"],
    "통계": ["확률분포", "통계적 추정"],
  },
  "미적분": {
    "수열의 극한": ["수열의 극한", "급수"],
    "미분법": ["여러 가지 함수의 미분", "여러 가지 미분법"],
    "적분법": ["여러 가지 적분법", "정적분의 활용"],
  },
};
